/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestReceiptGetApplicationGet } from '../fn/receipt-request/api-request-receipt-get-application-get';
import { ApiRequestReceiptGetApplicationGet$Params } from '../fn/receipt-request/api-request-receipt-get-application-get';
import { apiRequestReceiptGetPreviewGet } from '../fn/receipt-request/api-request-receipt-get-preview-get';
import { ApiRequestReceiptGetPreviewGet$Params } from '../fn/receipt-request/api-request-receipt-get-preview-get';
import { apiRequestReceiptGetRequestByIdGet } from '../fn/receipt-request/api-request-receipt-get-request-by-id-get';
import { ApiRequestReceiptGetRequestByIdGet$Params } from '../fn/receipt-request/api-request-receipt-get-request-by-id-get';
import { apiRequestReceiptInitialApplicationGet } from '../fn/receipt-request/api-request-receipt-initial-application-get';
import { ApiRequestReceiptInitialApplicationGet$Params } from '../fn/receipt-request/api-request-receipt-initial-application-get';
import { apiRequestReceiptInitialGet } from '../fn/receipt-request/api-request-receipt-initial-get';
import { ApiRequestReceiptInitialGet$Params } from '../fn/receipt-request/api-request-receipt-initial-get';
import { apiRequestReceiptSaveSubmitPost } from '../fn/receipt-request/api-request-receipt-save-submit-post';
import { ApiRequestReceiptSaveSubmitPost$Params } from '../fn/receipt-request/api-request-receipt-save-submit-post';
import { CourseBillingRequest } from '../models/course-billing-request';
import { InitReceiptByApplication } from '../models/init-receipt-by-application';
import { ReceiptRequest } from '../models/receipt-request';
import { ReceiptRequestApiRespModel } from '../models/receipt-request-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ReceiptRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestReceiptInitialGet()` */
  static readonly ApiRequestReceiptInitialGetPath = '/api/Request/Receipt/Initial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptInitialGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptInitialGet$Response(params?: ApiRequestReceiptInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequest>> {
    return apiRequestReceiptInitialGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptInitialGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptInitialGet(params?: ApiRequestReceiptInitialGet$Params, context?: HttpContext): Observable<ReceiptRequest> {
    return this.apiRequestReceiptInitialGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptRequest>): ReceiptRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestReceiptInitialApplicationGet()` */
  static readonly ApiRequestReceiptInitialApplicationGetPath = '/api/Request/Receipt/InitialApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptInitialApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptInitialApplicationGet$Response(params?: ApiRequestReceiptInitialApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseBillingRequest>> {
    return apiRequestReceiptInitialApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptInitialApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptInitialApplicationGet(params?: ApiRequestReceiptInitialApplicationGet$Params, context?: HttpContext): Observable<CourseBillingRequest> {
    return this.apiRequestReceiptInitialApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseBillingRequest>): CourseBillingRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestReceiptGetApplicationGet()` */
  static readonly ApiRequestReceiptGetApplicationGetPath = '/api/Request/Receipt/GetApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptGetApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetApplicationGet$Response(params?: ApiRequestReceiptGetApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InitReceiptByApplication>>> {
    return apiRequestReceiptGetApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptGetApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetApplicationGet(params?: ApiRequestReceiptGetApplicationGet$Params, context?: HttpContext): Observable<Array<InitReceiptByApplication>> {
    return this.apiRequestReceiptGetApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InitReceiptByApplication>>): Array<InitReceiptByApplication> => r.body)
    );
  }

  /** Path part for operation `apiRequestReceiptGetRequestByIdGet()` */
  static readonly ApiRequestReceiptGetRequestByIdGetPath = '/api/Request/Receipt/GetRequestById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptGetRequestByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetRequestByIdGet$Response(params?: ApiRequestReceiptGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequest>> {
    return apiRequestReceiptGetRequestByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptGetRequestByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetRequestByIdGet(params?: ApiRequestReceiptGetRequestByIdGet$Params, context?: HttpContext): Observable<ReceiptRequest> {
    return this.apiRequestReceiptGetRequestByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptRequest>): ReceiptRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestReceiptGetPreviewGet()` */
  static readonly ApiRequestReceiptGetPreviewGetPath = '/api/Request/Receipt/GetPreview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptGetPreviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetPreviewGet$Response(params?: ApiRequestReceiptGetPreviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequest>> {
    return apiRequestReceiptGetPreviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptGetPreviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestReceiptGetPreviewGet(params?: ApiRequestReceiptGetPreviewGet$Params, context?: HttpContext): Observable<ReceiptRequest> {
    return this.apiRequestReceiptGetPreviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptRequest>): ReceiptRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestReceiptSaveSubmitPost()` */
  static readonly ApiRequestReceiptSaveSubmitPostPath = '/api/Request/Receipt/SaveSubmit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestReceiptSaveSubmitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestReceiptSaveSubmitPost$Response(params?: ApiRequestReceiptSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequestApiRespModel>> {
    return apiRequestReceiptSaveSubmitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestReceiptSaveSubmitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestReceiptSaveSubmitPost(params?: ApiRequestReceiptSaveSubmitPost$Params, context?: HttpContext): Observable<ReceiptRequestApiRespModel> {
    return this.apiRequestReceiptSaveSubmitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptRequestApiRespModel>): ReceiptRequestApiRespModel => r.body)
    );
  }

}
